<template>
  <div class="board-table">
    <div v-for="post in state.list" :key="post.id" class="post-card">
      <div v-if="post.type == 'update'">
        <b-alert show variant="info">
          <b-link @click="onPopover(post.number)">{{post.number}}番</b-link>
          の投稿が編集されました。
          <span v-if="post.created_at !== null">
            ({{ $date(post.created_at).format('YYYY年MM月DD日 HH時mm分') }})
          </span>
        </b-alert>
      </div>
      <div v-else-if="post.type == 'delete'">
        <b-alert show variant="warning">
          {{post.number}}番
          の投稿が削除されました。
          <span v-if="post.created_at !== null">
            ({{ $date(post.created_at).format('YYYY年MM月DD日 HH時mm分') }})
          </span>
        </b-alert>
      </div>
      <div v-else>
        <b-card no-body>
          <b-card-header>
            {{ post.number }}. <strong>{{ post.subject }}</strong>
          </b-card-header>
          <b-card-body>
            <div class="message">
              <BoardMessage :message="post.message" />
            </div>
            <div v-if="post.users === 'my'">
              <b-nav align="right">
                <b-nav-item @click="onQuote(post.id)">引用</b-nav-item>
                <!--b-nav-item @click="onLink(post.id)">リンク</b-nav-item-->
                <b-nav-item @click="onEdit(post.id)">編集</b-nav-item>
                <b-nav-item @click="onDelete(post.id)">削除</b-nav-item>
              </b-nav>
            </div>
            <div v-else>
              <b-nav align="right">
                <b-nav-item @click="onQuote(post.id)">引用</b-nav-item>
                <!--b-nav-item @click="onLink(post.id)">リンク</b-nav-item-->
              </b-nav>
            </div>
          </b-card-body>
          <b-card-footer align="right">
            <span v-if="post.user_name !== null">
              {{ post.user_name }}
            </span>
            <span v-if="post.created_at !== null">
              ({{ $date(post.created_at).format('YYYY年MM月DD日 HH時mm分') }})
            </span>
            <span v-if="post.created_at !== post.updated_at">
              <font-awesome-icon icon="pen" />
            </span>
          </b-card-footer>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import BoardMessage from './BoardMessage';

export default {
  name: 'BoardTable',

  components: { BoardMessage },

  props: {
    refsMessage: Object,
  },

  computed: {
    ...mapState({ state: 'posts' }),
  },

  methods: {
    ...mapActions('posts', ['deleteItem', 'addQuote', 'addLink', 'changeForm']),

    onPopover(number) {
      console.log(number);
    },

    onQuote(id) {
      this.$scrollTo('#anchor-board-form');
      this.addQuote({ id, refsMessage: this.refsMessage });
    },

    /*
    onLink(id) {
      this.$scrollTo('#anchor-board-form');
      this.addLink({ id, refsMessage: this.refsMessage });
    },
    */

    onEdit(id) {
      this.$scrollTo('#anchor-board-form');
      this.changeForm(id);
    },

    onDelete(id) {
      this.$utils.confirm('投稿削除', '削除してよろしいですか？', () => {
        this.deleteItem(id);
      });
    },
  },

  mounted() {
    this.$store.dispatch('posts/searchList', this.state);
  },
};
</script>

<style scoped>
.posts {
  text-align: left;
}
.posts dt {
  border-top: 1px solid black;
}
.message {
  /*white-space: pre-wrap;*/
}
.post-card {
  margin: 1em auto;
}
</style>
